@if (invalidLink()) {
<h3> link expired</h3>
} @else {
<div class="page-wraper">
    <div class="top-header flexbox-row bg-primary p-3">
        <ul class="list-style-none header-list w-100">
            <li class="header-list-item">
                <p>Engagement Name:</p>
                <h6 class="title">{{clientInformation?.engagementName}}</h6>
            </li>
            <li class="header-list-item">
                <p>Client:</p>
                <h6 class="title">{{clientInformation?.clientName}}</h6>
            </li>
            <li class="header-list-item">
                <p>Firm Name:</p>
                <h6 class="title">{{clientInformation?.firmName}}</h6>
            </li>
            <li class="header-list-item">
                <p>Year End:</p>
                <h6 class="title">{{clientInformation?.yearEnd}}</h6>
            </li>
        </ul>
    </div>
    <div class="page-title-block flexbox-column gap-4 bg-white text-center pt-5">
        <h1 class="fs-36">Banking and Financials</h1>
    </div>

    <div class="content-block-main">
        <div class="card mb-3 w-100 recent-activities p-24 bg-gray-50 link-bank-instruction">
            <div class="card-header p-0 pb-24">
                <h3 class="title text-gray-7">Accounts Details</h3>
                <!-- <span class="d-flex align-items-center gap-24">
                    <button mat-button mat-stroked-button color="error" class="button-medium" (click)="disconnectBankingModel()">
                        Disconnect All</button>
                </span> -->
            </div>
            <div class="card-body gap-24 py-24 p-0 border-bottom">
                @for (institute of bankingData(); track institute) {
                <div class="d-flex justify-content-between">
                    <span class="d-flex gap-14 align-items-center institute-logo">
                        <img [src]="getCachedLogo(institute.institutionId)" [alt]="institute?.institutionName">
                        <h4>{{institute?.institutionName}}</h4>
                    </span>
                    <!-- <button mat-button mat-stroked-button color="error" class="button-medium" (click)="unlinkBankingModel(institute)">
                                Disconnect
                            </button> -->
                </div>
                @for (account of institute.plaidAccounts; track $index) {
                <div class="card">
                    <div class="d-flex justify-content-between align-items-center plaid-card">
                        <span>
                            <h5 class="text-link">{{account?.name}}</h5>
                            <p><span class="font-poppins">********</span>{{account.mask}}</p>
                        </span>
                        <p class="fw-medium text-success d-flex gap-6 align-items-center"> <i
                                class="fa-light fa-circle-check fw-medium fs-18"></i>Connected</p>
                    </div>
                </div>
                }
                }
            </div>
        </div>

    </div>
</div>
}

<ng-template #disconnectBanking>
    <div class="countable-dialog deleteLetterFolderDialog w-100" (click)="$event.stopPropagation()" style="max-width: 400px;">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-error badge-circle icon-bordered-error">
                <i class="fa-regular fa-circle-exclamation"></i>
            </span>
            <h4 class="title text-center">
                Disconnect All Banking
            </h4>

            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="material-icons clear-icon">close</i>
            </button>
        </div>

        @if (isConfirmEnabled()) {
        <div mat-dialog-content class="content dialog-body-content text-center gap-8 mt-2 mb-32">
            <div class="d-flex flex-column gap-16">
                <p class="fs-16 text-center pt-3 pb-3">
                    If you still wish to proceed, please enter 'Disconnect' below
                </p>
                <mat-form-field class="fixed-label w-100" floatLabel="always">
                    <input class="bg-white shadow-none" matInput [formControl]="deactivateCtrl" placeholder="Disconnect"
                        maxlength="10">
                </mat-form-field>
            </div>
        </div>
        } @else {
        <div mat-dialog-content class="content dialog-body-content text-center gap-8 pt-2">
            <h5>This action will disconnect the entire banking connection</h5>
            <h5 class="text-error">Please note the impacts before removing:</h5>
            <div class="d-flex flex-column gap-16 pt-3">
                <div class="d-flex gap-10">
                    <div class="flex_none">
                        <i class="fa-regular fa-circle-xmark fs-20 text-error"></i>
                    </div>
                    <p class="fs-16 text-left">Data will not be connected with Luca & some prompts may not work</p>
                </div>
                <div class="d-flex gap-10">
                    <div class="flex_none">
                        <i class="fa-regular fa-circle-xmark fs-20 text-error"></i>
                    </div>
                    <p class="fs-16 text-left">Real-time access to banking information will not be available</p>
                </div>
                <div class="d-flex gap-10">
                    <div class="flex_none">
                        <i class="fa-regular fa-circle-check text-primary fs-20"></i>
                    </div>
                    <p class="fs-16 text-left">Downloaded banking statements or documents will be saved in the Documents
                        folder.
                    </p>
                </div>
            </div>
            <h5 class="mt-2 text-gray-7">Are you sure you want to disconnect banking?</h5>
        </div>
        }
        <div mat-dialog-actions class="dialog-footer button-group">
            <button mat-button mat-stroked-button class="button-normal" color="dark" [mat-dialog-close]="false">No
            </button>
            @if (isConfirmEnabled()) {
            <button mat-button mat-flat-button class="button-normal" color="error" [mat-dialog-close]="true"
                [disabled]="!deactivateInfo()">Confirm</button>
            } @else {
            <button mat-button mat-flat-button class="button-normal" color="error" (click)="enableConfirm()">Yes
            </button>
            }
        </div>
    </div>
</ng-template>